const countyConfigReportsReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_COUNTY_CONFIG_REPORTS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigReportsReducer;